const BASE_URL = 'https://raider.io/api/v1'

function createUrl(path, params = {}) {
  const url = new URL(`${BASE_URL}${path}`)

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      url.searchParams.set(key, value)
    }
  })

  return url.toString()
}

async function request(path, params) {
  const response = await fetch(createUrl(path, params))

  if (!response.ok) {
    const text = await response.text()
    throw new Error(text || `Raider.io request failed: ${response.status}`)
  }

  return response.json()
}

export async function getRaids(expansionId = 10) {
  return request('/raiding/static-data', { expansion_id: expansionId })
}

export async function getRaidRankings(params) {
  return request('/raiding/raid-rankings', params)
}

export async function getRaidHallOfFame(params) {
  return request('/raiding/hall-of-fame', params)
}

export async function getMythicPlusStaticData(expansionId = 10) {
  return request('/mythic-plus/static-data', { expansion_id: expansionId })
}

export async function getMythicPlusRuns(params) {
  return request('/mythic-plus/runs', params)
}

export async function getAffixes(region = 'eu', locale = 'ru') {
  return request('/mythic-plus/affixes', { region, locale })
}

export async function getSeasonCutoffs(region = 'eu', season) {
  return request('/mythic-plus/season-cutoffs', { region, season })
}

export async function getLeaderboardCapacity(region = 'eu', realm = '', scope = 'current') {
  return request('/mythic-plus/leaderboard-capacity', { region, realm, scope })
}

export async function getCharacterProfile({ region, realm, name, fields }) {
  return request('/characters/profile', {
    region,
    realm,
    name,
    fields,
  })
}
